import { render, staticRenderFns } from "./SecondaryBox.vue?vue&type=template&id=26f93b14&scoped=true"
import script from "./SecondaryBox.vue?vue&type=script&lang=js"
export * from "./SecondaryBox.vue?vue&type=script&lang=js"
import style0 from "./SecondaryBox.vue?vue&type=style&index=0&id=26f93b14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f93b14",
  null
  
)

export default component.exports